(ns shared.core.components.pill
  (:require [shared.core.style :as style]
            [shared.core.components.interactive :refer [interactive]]
            [shared.core.components.tooltip :refer [tooltip]]
            [shared.core.util :as util]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]))

(defn pill [{:keys [style dark-style description on-click]} & contents]
  (let [pill-args {:style (merge {:background-color (style/color :gray :base)
                                  :border-radius 2
                                  :color (style/color :white :base)
                                  :font-size 11
                                  :font-weight style/font-medium-weight
                                  :padding 3
                                  :transition "0.2s"}
                                 (when on-click
                                   {:cursor :pointer})
                                 style)
                   :theme (style/dark-style (merge {}
                                                   dark-style))
                   :on-click on-click}]
    (if description
      [tooltip
       {:placement :bottom
        :tooltip-content [:span {:style {:color (style/color :white :base)}}
                          description]
        :target-content (into [theme/theme :div pill-args] contents)}]
      (into [theme/theme :div pill-args] contents))))

(defn light-gray-pill [{:keys [style] :as args} & contents]
  (into [pill (assoc args :style (merge {:background-color (style/color :gray :shade-7)
                                         :color (style/color :gray :base)}
                                        style))]
        contents))

(defn light-gray-on-background-pill [{:keys [style] :as args} & contents]
  (into [light-gray-pill (assoc args :style (merge {:color (style/color :on-background :base)}
                                                   style))]
        contents))

(defn click-to-copy-pill [{:keys [label label-style dark-label-style label-hover-style dark-label-hover-style
                                  description spacing-margins? copy-text]
                           :or {spacing-margins? true}}]
  [tooltip
   {:placement :bottom
    :tooltip-content [:span {:style {:color (style/color :white :base)}}
                      description]
    :target-content [theme/theme interactive
                     :div {:style (merge {:background-color (style/color :gray :shade-2)
                                          :border-radius 2
                                          :color (style/color :gray :base)
                                          :font-size 11
                                          :font-weight style/font-medium-weight
                                          :cursor :pointer
                                          :padding 3
                                          :transition "0.2s"}
                                         (when spacing-margins?
                                           {:margin-top 4
                                            :margin-right 4})
                                         label-style)
                           :theme (style/dark-style (merge {}
                                                           dark-label-style))
                           :hover-style (merge {:background-color (style/color :gray :base)
                                                :color (style/color :white :base)}
                                               label-hover-style)
                           :dark-hover-style (merge {}
                                                    dark-label-hover-style)
                           :on-click #(do
                                        (re/dispatch-sync [:core/copy-to-clipboard
                                                           (or copy-text label)
                                                           {:notify? true}])
                                        (util/stop-event %))}
                     label]}])
